'use strict';

var React = require('react');
var styled$1 = require('styled-components');
var _extends = require('./extends-5ede7877.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled$1);

/* eslint-disable no-console */
var DEV = process.env.NODE_ENV !== 'production';
var identity = function identity(x) {
  return x;
};
var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !Number.isNaN(n);
};
var string = function string(n) {
  return typeof n === 'string' && n !== '';
};
var obj = function obj(n) {
  return typeof n === 'object' && n !== null;
};
var negative = function negative(n) {
  return num(n) && n < 0;
};
var get = function get(from, path) {
  var paths = String(path).split('.');
  var pathsLength = paths.length;
  var result = from;

  for (var i = 0; i < pathsLength; i += 1) {
    if (result === undefined) return result;
    var _path = paths[i];
    result = is(result[_path]) ? result[_path] : undefined;
  }

  return result;
};
var assign = function assign(a, b) {
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax, guard-for-in

  for (var key in b) {
    a[key] = b[key];
  }

  return a;
};
var merge = function merge(a, b) {
  if (!is(b)) return a; // eslint-disable-next-line no-restricted-syntax

  for (var key in b) {
    // eslint-disable-next-line no-continue
    if (obj(a[key])) {
      a[key] = merge(assign({}, a[key]), b[key]);
    } else {
      a[key] = b[key];
    }
  }

  return a;
};
var warn = function warn(condition, message) {
  if (DEV) {
    if (!condition && console.error) {
      console.error(message);
    }
  }
};
function cascade(value, arg) {
  if (typeof value === 'function') {
    return cascade(value(arg), arg);
  }

  return value;
}
var getThemeValue = function getThemeValue(props, path, initial) {
  if (initial === void 0) {
    initial = props.theme;
  }

  return cascade(get(initial, path), props);
};
function omit(object, values) {
  var result = {}; // eslint-disable-next-line no-restricted-syntax

  for (var key in object) {
    if (values.indexOf(key) === -1) {
      result[key] = object[key];
    }
  }

  return result;
}
/* eslint-disable no-continue, no-loop-func, no-cond-assign */

function flattenStrings(array) {
  return array.reduce(function (flattenedArray, value) {
    var lastIndex = flattenedArray.length - 1;
    var last = flattenedArray[lastIndex];

    if (typeof last === 'string' && typeof value === 'string') {
      flattenedArray[lastIndex] = last + value;
    } else {
      flattenedArray.push(value);
    }

    return flattenedArray;
  }, []);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var round = function round(value) {
  return Math.round(value * Math.pow(10, 4)) / Math.pow(10, 4);
};

var unit = function unit(_unit) {
  return function (value) {
    return num(value) && value !== 0 ? "" + value + _unit : value;
  };
};
var px = /*#__PURE__*/unit('px');

var pxToRem = function pxToRem(value) {
  return round(value / 16);
};
var rpx = function rpx(value) {
  if (!string(value) || value.length < 4) return value;
  var unit = value.slice(-3);
  if (unit !== 'rpx') return value;
  var n = Number(value.slice(0, value.length - 3));
  if (n === 0) return 0;
  return pxToRem(n) + "rem";
};
var percent = function percent(n) {
  return n !== 0 && n >= -1 && n <= 1 ? round(n * 100) + "%" : n;
};

var DEFAULT_BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
function getBreakpoints(props) {
  var themeBreakpoints = getThemeValue(props, 'breakpoints');
  if (is(themeBreakpoints)) return themeBreakpoints;
  return DEFAULT_BREAKPOINTS;
}
var mediaMinWidth = function mediaMinWidth(value) {
  return value ? "@media (min-width: " + value + ")" : null;
};
var mediaMaxWidth = function mediaMaxWidth(value) {
  return value ? "@media (max-width: " + value + ")" : null;
};
var mediaBetweenWidth = function mediaBetweenWidth(min, max) {
  return "@media (min-width: " + min + ") and (max-width: " + max + ")";
};
/**
 * Minimum breakpoint width.
 * Null for the smallest breakpoint.
 */

var getBreakpointMin = function getBreakpointMin(breakpoints, key) {
  var value = breakpoints[key];
  return value === 0 ? null : px(value);
};
/**
 * Maximum breakpoint width. Null for the largest (last) breakpoint.
 * The maximum value is calculated as the minimum of the next one less 0.02px
 * to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
 * See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
 * Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
 * See https://bugs.webkit.org/show_bug.cgi?id=178261
 */

var getBreakpointMax = function getBreakpointMax(breakpoints, key) {
  var breakPoint = breakpoints[key];
  return breakPoint === 0 ? null : px(breakPoint - 0.02);
};

/* eslint-disable no-continue, no-underscore-dangle, no-restricted-syntax, guard-for-in, no-multi-assign */
var cacheSupported = typeof Map !== 'undefined' && typeof WeakMap !== 'undefined';
var caches = cacheSupported ? /*#__PURE__*/new WeakMap() : null;

function getThemeCache(theme) {
  if (caches.has(theme)) return caches.get(theme);
  var cache = {};
  caches.set(theme, cache);
  return cache;
}

var noopCache = {
  has: function has() {
    return false;
  },
  set: function set() {},
  get: function get() {}
};

function getCacheNamespace(theme, namespace) {
  if (!cacheSupported || !theme) return noopCache;
  var cache = getThemeCache(theme);
  cache[namespace] = cache[namespace] || new Map();
  return cache[namespace];
}

var themeGetterId = 0;
var themeGetter = function themeGetter(_ref) {
  var name = _ref.name,
      defaultTransform = _ref.transform,
      key = _ref.key,
      defaultVariants = _ref.defaultVariants,
      compose = _ref.compose;
  var id = themeGetterId++;

  var getter = function getter(value) {
    return function (props) {
      var res = value;
      if (!string(value) && !num(value)) return res;
      var cache = getCacheNamespace(props.theme, "__themeGetter" + id);
      if (cache.has(value)) return cache.get(value);
      var variants = is(key) ? getThemeValue(props, key) : null;
      variants = is(variants) ? variants : defaultVariants;
      res = is(variants) ? getThemeValue(props, value, variants) : null;
      res = is(res) ? res : value;
      var transform = (name && props.theme && props.theme.transformers ? props.theme.transformers[name] : null) || defaultTransform;

      if (transform) {
        res = transform(res, {
          rawValue: value,
          variants: variants,
          props: props
        });
      }

      res = compose ? compose(res)(props) : res;
      cache.set(value, res);
      return res;
    };
  };

  getter.meta = {
    name: name,
    transform: defaultTransform
  };
  return getter;
};

function styleFromValue(cssProperties, value, props, themeGet, cache) {
  if (obj(value)) return null;
  if (cache.has(value)) return cache.get(value);
  var computedValue = themeGet(value)(props);
  if (!string(computedValue) && !num(computedValue)) return null;
  var style = {};

  for (var key in cssProperties) {
    style[cssProperties[key]] = computedValue;
  }

  cache.set(value, style);
  return style;
}

function createStyleGenerator(getStyle, props, generators) {
  getStyle.meta = {
    props: props,
    getStyle: getStyle,
    generators: generators
  };
  return getStyle;
}

function getMedias(props) {
  var breakpoints = getBreakpoints(props);
  var medias = {};

  for (var breakpoint in breakpoints) {
    medias[breakpoint] = mediaMinWidth(getBreakpointMin(breakpoints, breakpoint));
  }

  return medias;
}

function getCachedMedias(props, cache) {
  if (cache.has('_medias')) {
    return cache.get('_medias');
  }

  var medias = getMedias(props);
  cache.set('_medias', medias);
  return medias;
}

function reduceBreakpoints(props, values, getStyle, cache) {
  if (getStyle === void 0) {
    getStyle = identity;
  }

  var medias = cache ? getCachedMedias(props, cache) : getMedias(props);
  var styles = {};

  for (var breakpoint in values) {
    var _style = getStyle(values[breakpoint]);

    if (_style === null) continue;
    var media = medias[breakpoint];

    if (media === null) {
      styles = merge(styles, _style);
    } else {
      styles[media] = styles[media] ? assign(styles[media], _style) : _style;
    }
  }

  return styles;
}

function getStyleFactory(prop, cssProperties, themeGet) {
  return function getStyle(props) {
    var value = props[prop];
    if (!is(value)) return null;
    var cache = getCacheNamespace(props.theme, prop);

    if (obj(value)) {
      return reduceBreakpoints(props, value, function (breakpointValue) {
        return styleFromValue(cssProperties, breakpointValue, props, themeGet, cache);
      }, cache);
    }

    return styleFromValue(cssProperties, value, props, themeGet, cache);
  };
}

function indexGeneratorsByProp(styles) {
  var index = {};

  for (var i = 0; i < styles.length; i++) {
    var _style2 = styles[i];

    if (_style2 && _style2.meta) {
      var propsKeys = Object.keys(_style2.meta.props);

      for (var j = 0; j < propsKeys.length; j++) {
        var prop = _style2.meta.props[propsKeys[j]];
        index[prop] = _style2;
      }
    }
  }

  return index;
}

function getMediaOrder(styles, props) {
  var medias = {};
  var breakpoints = getBreakpoints(props);
  var stylesProperties = Object.keys(styles);

  for (var key in breakpoints) {
    var breakpoint = breakpoints[key];
    var currentMediaKey = "@media (min-width: " + breakpoint + "px)";
    var isValid = stylesProperties.includes(currentMediaKey);
    if (!isValid) continue;
    medias[currentMediaKey] = styles[currentMediaKey];
  }

  return medias;
}

function compose() {
  var flatGenerators = [];

  for (var _len = arguments.length, generators = new Array(_len), _key = 0; _key < _len; _key++) {
    generators[_key] = arguments[_key];
  }

  generators.forEach(function (gen) {
    warn(gen, "Undefined generator in \"compose\" method");
    if (!gen) return;

    if (gen.meta.generators) {
      flatGenerators = [].concat(flatGenerators, gen.meta.generators);
    } else {
      flatGenerators.push(gen);
    }
  });
  var generatorsByProp = indexGeneratorsByProp(flatGenerators);

  function getStyle(props) {
    var styles = {};

    for (var key in props) {
      var generator = generatorsByProp[key];

      if (generator) {
        var _style3 = generator.meta.getStyle(props);

        merge(styles, _style3);
      }
    }

    return assign(getMediaOrder(styles, props), styles);
  }

  var props = flatGenerators.reduce(function (keys, generator) {
    return [].concat(keys, generator.meta.props);
  }, []);
  return createStyleGenerator(getStyle, props, generators);
}
function style(_ref2) {
  var prop = _ref2.prop,
      cssProperty = _ref2.cssProperty,
      _ref2$key = _ref2.key,
      key = _ref2$key === void 0 ? null : _ref2$key,
      _ref2$transform = _ref2.transform,
      transform = _ref2$transform === void 0 ? null : _ref2$transform,
      _ref2$themeGet = _ref2.themeGet,
      themeGet = _ref2$themeGet === void 0 ? null : _ref2$themeGet;
  var cssProperties = !Array.isArray(cssProperty) ? [cssProperty || prop] : cssProperty;

  if (Array.isArray(prop)) {
    return compose.apply(void 0, prop.map(function (prop) {
      return style({
        prop: prop,
        cssProperty: cssProperties,
        key: key,
        transform: transform,
        themeGet: themeGet
      });
    }));
  }

  themeGet = themeGet || themeGetter({
    key: key,
    transform: transform
  });
  var getStyle = getStyleFactory(prop, cssProperties, themeGet);
  return createStyleGenerator(getStyle, [prop]);
}

var getColor = /*#__PURE__*/themeGetter({
  name: 'color',
  key: 'colors'
});
var getPx = /*#__PURE__*/themeGetter({
  name: 'px',
  transform: function transform(value) {
    return px(rpx(value));
  }
});
var getPercent = /*#__PURE__*/themeGetter({
  name: 'percent',
  transform: percent,
  compose: getPx
});
var getRadius = /*#__PURE__*/themeGetter({
  name: 'radius',
  key: 'radii',
  compose: getPx
});
var getTransition = /*#__PURE__*/themeGetter({
  name: 'transition',
  key: 'transitions'
}); // Style

var opacity = /*#__PURE__*/style({
  prop: 'opacity'
});
var overflow = /*#__PURE__*/style({
  prop: 'overflow'
});
var transition = /*#__PURE__*/style({
  prop: 'transition',
  themeGet: getTransition
});
var basics = /*#__PURE__*/compose(opacity, overflow, transition);

var background = /*#__PURE__*/style({
  prop: 'background'
});
var backgroundColor = /*#__PURE__*/style({
  prop: ['backgroundColor', 'bg'],
  cssProperty: 'backgroundColor',
  themeGet: getColor
});
var backgroundImage = /*#__PURE__*/style({
  prop: 'backgroundImage'
});
var backgroundSize = /*#__PURE__*/style({
  prop: 'backgroundSize'
});
var backgroundPosition = /*#__PURE__*/style({
  prop: 'backgroundPosition'
});
var backgroundRepeat = /*#__PURE__*/style({
  prop: 'backgroundRepeat'
});
var backgrounds = /*#__PURE__*/compose(background, backgroundColor, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat);

var getBorder = /*#__PURE__*/themeGetter({
  name: 'border',
  key: 'borders',
  transform: function transform(n) {
    return num(n) && n > 0 ? px(n) + " solid" : n;
  }
});
var getBorderWidth = /*#__PURE__*/themeGetter({
  name: 'borderWidth',
  key: 'borderWidths',
  compose: getPx
});
var getBorderStyle = /*#__PURE__*/themeGetter({
  name: 'borderStyle',
  key: 'borderStyles'
}); // Style

var border = /*#__PURE__*/style({
  prop: 'border',
  themeGet: getBorder
});
var borderTop = /*#__PURE__*/style({
  prop: 'borderTop',
  themeGet: getBorder
});
var borderTopColor = /*#__PURE__*/style({
  prop: 'borderTopColor',
  themeGet: getColor
});
var borderRight = /*#__PURE__*/style({
  prop: 'borderRight',
  themeGet: getBorder
});
var borderRightColor = /*#__PURE__*/style({
  prop: 'borderRightColor',
  themeGet: getColor
});
var borderBottom = /*#__PURE__*/style({
  prop: 'borderBottom',
  themeGet: getBorder
});
var borderBottomColor = /*#__PURE__*/style({
  prop: 'borderBottomColor',
  themeGet: getColor
});
var borderLeft = /*#__PURE__*/style({
  prop: 'borderLeft',
  themeGet: getBorder
});
var borderLeftColor = /*#__PURE__*/style({
  prop: 'borderLeftColor',
  themeGet: getColor
});
var borderColor = /*#__PURE__*/style({
  prop: 'borderColor',
  themeGet: getColor
});
var borderWidth = /*#__PURE__*/style({
  prop: 'borderWidth',
  themeGet: getBorderWidth
});
var borderStyle = /*#__PURE__*/style({
  prop: 'borderStyle',
  themeGet: getBorderStyle
});
var borderRadius = /*#__PURE__*/style({
  prop: 'borderRadius',
  themeGet: getRadius
});
var borders = /*#__PURE__*/compose(border, borderTop, borderTopColor, borderRight, borderRightColor, borderBottom, borderBottomColor, borderLeft, borderLeftColor, borderColor, borderWidth, borderStyle, borderRadius);

var getSize = /*#__PURE__*/themeGetter({
  name: 'size',
  key: 'sizes',
  compose: getPercent
}); // Styles

var display = /*#__PURE__*/style({
  prop: 'display'
});
var width = /*#__PURE__*/style({
  prop: 'width',
  themeGet: getSize
});
var height = /*#__PURE__*/style({
  prop: 'height',
  themeGet: getSize
});
var maxWidth = /*#__PURE__*/style({
  prop: 'maxWidth',
  themeGet: getSize
});
var maxHeight = /*#__PURE__*/style({
  prop: 'maxHeight',
  themeGet: getSize
});
var minWidth = /*#__PURE__*/style({
  prop: 'minWidth',
  themeGet: getSize
});
var minHeight = /*#__PURE__*/style({
  prop: 'minHeight',
  themeGet: getSize
});
var size = /*#__PURE__*/style({
  prop: 'size',
  cssProperty: ['width', 'height'],
  themeGet: getSize
});
var verticalAlign = /*#__PURE__*/style({
  prop: 'verticalAlign'
});
var layout = /*#__PURE__*/compose(display, width, height, maxWidth, maxHeight, minWidth, minHeight, size, verticalAlign);

var alignItems = /*#__PURE__*/style({
  prop: 'alignItems'
});
var alignContent = /*#__PURE__*/style({
  prop: 'alignContent'
});
var justifyContent = /*#__PURE__*/style({
  prop: 'justifyContent'
});
var justifyItems = /*#__PURE__*/style({
  prop: 'justifyItems'
});
var flexWrap = /*#__PURE__*/style({
  prop: 'flexWrap'
});
var flexGrow = /*#__PURE__*/style({
  prop: 'flexGrow'
});
var flexShrink = /*#__PURE__*/style({
  prop: 'flexShrink'
});
var flexBasis = /*#__PURE__*/style({
  prop: 'flexBasis',
  themeGet: getPercent
});
var flexDirection = /*#__PURE__*/style({
  prop: 'flexDirection'
});
var flex = /*#__PURE__*/style({
  prop: 'flex'
});
var justifySelf = /*#__PURE__*/style({
  prop: 'justifySelf'
});
var alignSelf = /*#__PURE__*/style({
  prop: 'alignSelf'
});
var order = /*#__PURE__*/style({
  prop: 'order'
});
var flexboxes = /*#__PURE__*/compose(display, alignItems, alignContent, justifyContent, justifyItems, flexWrap, flexBasis, flexShrink, flexGrow, flexDirection, flex, justifySelf, alignSelf, order);

function toNegative(value) {
  if (string(value)) return "-" + value;
  return value * -1;
} // Getters


var getSpace = /*#__PURE__*/themeGetter({
  name: 'space',
  key: 'space',
  defaultVariants: [0, 4, 8, 16, 24, 48, 96, 144, 192, 240],
  compose: getPx,
  transform: function transform(_, _ref) {
    var rawValue = _ref.rawValue,
        variants = _ref.variants,
        props = _ref.props;

    if (string(rawValue)) {
      var _neg = rawValue.startsWith('-');

      var absoluteValue = _neg ? rawValue.substr(1) : rawValue;
      var variantValue = getThemeValue(props, absoluteValue, variants);

      var _value = is(variantValue) ? variantValue : absoluteValue;

      return _neg ? toNegative(_value) : _value;
    }

    var abs = Math.abs(rawValue);
    var neg = negative(rawValue);
    var value = is(variants[abs]) ? variants[abs] : abs;
    return neg ? toNegative(value) : value;
  }
}); // Styles

var margin = /*#__PURE__*/style({
  prop: ['margin', 'm'],
  cssProperty: 'margin',
  themeGet: getSpace
});
var marginTop = /*#__PURE__*/style({
  prop: ['marginTop', 'mt'],
  cssProperty: 'marginTop',
  themeGet: getSpace
});
var marginRight = /*#__PURE__*/style({
  prop: ['marginRight', 'mr'],
  cssProperty: 'marginRight',
  themeGet: getSpace
});
var marginBottom = /*#__PURE__*/style({
  prop: ['marginBottom', 'mb'],
  cssProperty: 'marginBottom',
  themeGet: getSpace
});
var marginLeft = /*#__PURE__*/style({
  prop: ['marginLeft', 'ml'],
  cssProperty: 'marginLeft',
  themeGet: getSpace
});
var mx = /*#__PURE__*/style({
  prop: 'mx',
  cssProperty: ['marginRight', 'marginLeft'],
  themeGet: getSpace
});
var my = /*#__PURE__*/style({
  prop: 'my',
  cssProperty: ['marginTop', 'marginBottom'],
  themeGet: getSpace
});
var padding = /*#__PURE__*/style({
  prop: ['padding', 'p'],
  cssProperty: 'padding',
  themeGet: getSpace
});
var paddingTop = /*#__PURE__*/style({
  prop: ['paddingTop', 'pt'],
  cssProperty: 'paddingTop',
  themeGet: getSpace
});
var paddingRight = /*#__PURE__*/style({
  prop: ['paddingRight', 'pr'],
  cssProperty: 'paddingRight',
  themeGet: getSpace
});
var paddingBottom = /*#__PURE__*/style({
  prop: ['paddingBottom', 'pb'],
  cssProperty: 'paddingBottom',
  themeGet: getSpace
});
var paddingLeft = /*#__PURE__*/style({
  prop: ['paddingLeft', 'pl'],
  cssProperty: 'paddingLeft',
  themeGet: getSpace
});
var px$1 = /*#__PURE__*/style({
  prop: 'px',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: getSpace
});
var py = /*#__PURE__*/style({
  prop: 'py',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: getSpace
});
var space = /*#__PURE__*/compose(margin, marginTop, marginRight, marginBottom, marginLeft, mx, my, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, px$1, py);

var gridGap = /*#__PURE__*/style({
  prop: 'gridGap',
  themeGet: getSpace
});
var gridColumnGap = /*#__PURE__*/style({
  prop: 'gridColumnGap',
  themeGet: getSpace
});
var gridRowGap = /*#__PURE__*/style({
  prop: 'gridRowGap',
  themeGet: getSpace
});
var gridColumn = /*#__PURE__*/style({
  prop: 'gridColumn'
});
var gridRow = /*#__PURE__*/style({
  prop: 'gridRow'
});
var gridAutoFlow = /*#__PURE__*/style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = /*#__PURE__*/style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = /*#__PURE__*/style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = /*#__PURE__*/style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = /*#__PURE__*/style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = /*#__PURE__*/style({
  prop: 'gridTemplateAreas'
});
var gridArea = /*#__PURE__*/style({
  prop: 'gridArea'
});
var grids = /*#__PURE__*/compose(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

var getZIndex = /*#__PURE__*/themeGetter({
  name: 'zIndex',
  key: 'zIndices'
}); // Styles

var position = /*#__PURE__*/style({
  prop: 'position'
});
var zIndex = /*#__PURE__*/style({
  prop: 'zIndex',
  themeGet: getZIndex
});
var top = /*#__PURE__*/style({
  prop: 'top',
  themeGet: getPx
});
var right = /*#__PURE__*/style({
  prop: 'right',
  themeGet: getPx
});
var bottom = /*#__PURE__*/style({
  prop: 'bottom',
  themeGet: getPx
});
var left = /*#__PURE__*/style({
  prop: 'left',
  themeGet: getPx
});
var positioning = /*#__PURE__*/compose(position, zIndex, top, right, bottom, left);

var getShadow = /*#__PURE__*/themeGetter({
  name: 'shadow',
  key: 'shadows'
}); // Style

var boxShadow = /*#__PURE__*/style({
  prop: 'boxShadow',
  themeGet: getShadow
});
var textShadow = /*#__PURE__*/style({
  prop: 'textShadow',
  themeGet: getShadow
});
var shadows = /*#__PURE__*/compose(boxShadow, textShadow);

var getFont = /*#__PURE__*/themeGetter({
  name: 'font',
  key: 'fonts'
});
var getLineHeight = /*#__PURE__*/themeGetter({
  name: 'lineHeight',
  key: 'lineHeights',
  transform: rpx
});
var getFontWeight = /*#__PURE__*/themeGetter({
  name: 'fontWeight',
  key: 'fontWeights'
});
var getLetterSpacing = /*#__PURE__*/themeGetter({
  name: 'letterSpacing',
  key: 'letterSpacings',
  compose: getPx
}); // Styles

var fontFamily = /*#__PURE__*/style({
  prop: 'fontFamily',
  themeGet: getFont
});
var getFontSize = /*#__PURE__*/themeGetter({
  name: 'fontSize',
  key: 'fontSizes',
  defaultVariants: [0, 12, 14, 16, 20, 24, 32, 48, 64, 72],
  compose: getPx
});
var fontSize = /*#__PURE__*/style({
  prop: 'fontSize',
  themeGet: getFontSize
});
var lineHeight = /*#__PURE__*/style({
  prop: 'lineHeight',
  themeGet: getLineHeight
});
var fontWeight = /*#__PURE__*/style({
  prop: 'fontWeight',
  themeGet: getFontWeight
});
var fontStyle = /*#__PURE__*/style({
  prop: 'fontStyle'
});
var textAlign = /*#__PURE__*/style({
  prop: 'textAlign'
});
var letterSpacing = /*#__PURE__*/style({
  prop: 'letterSpacing',
  themeGet: getLetterSpacing
});
var color = /*#__PURE__*/style({
  prop: 'color',
  themeGet: getColor
});
var textTransform = /*#__PURE__*/style({
  prop: 'textTransform'
});
var typography = /*#__PURE__*/compose(fontFamily, fontSize, fontStyle, lineHeight, fontWeight, textAlign, letterSpacing, color, textTransform);

var row = /*#__PURE__*/createStyleGenerator(function () {
  return {
    boxSizing: 'border-box',
    flexGrow: 1,
    flexWrap: 'wrap',
    display: 'flex'
  };
}, ['row']);

function getColStyle(props, size) {
  if (size === true) {
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    };
  }

  if (size === 'auto') {
    return {
      flex: "0 0 auto",
      maxWidth: 'none',
      width: 'auto'
    };
  }

  var sizeWidth = getPercent(size)(props);
  return {
    flex: "0 0 " + sizeWidth,
    maxWidth: sizeWidth
  };
}

var col = /*#__PURE__*/createStyleGenerator(function (props) {
  var value = props.col;
  var common = {
    boxSizing: 'border-box',
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  };

  if (obj(value)) {
    var breakpointsStyle = reduceBreakpoints(props, value, function (breakpointValue) {
      return getColStyle(props, breakpointValue);
    });
    return _extends._extends({}, common, breakpointsStyle);
  }

  return _extends._extends({}, common, getColStyle(props, value));
}, ['col']);
var xgrids = /*#__PURE__*/compose(row, col);

var system = /*#__PURE__*/compose(backgrounds, basics, borders, flexboxes, grids, layout, positioning, shadows, space, typography, xgrids);

var th = function th(path) {
  return function (props) {
    var value = getThemeValue(props, path);
    warn(is(value), "value \"" + path + "\" not found in theme");
    return value;
  };
};
[getColor, getPx, getPercent, getRadius, getBorder, getBorderWidth, getBorderStyle, getShadow, getSize, getZIndex, getSpace, getFont, getFontSize, getLineHeight, getFontWeight, getLetterSpacing, getTransition].forEach(function (themeGetter) {
  th[themeGetter.meta.name] = themeGetter;
});

var variant = function variant(_ref) {
  var _ref$key = _ref.key,
      key = _ref$key === void 0 ? null : _ref$key,
      defaultValue = _ref["default"],
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop;
  return function (props) {
    var themeVariants = is(key) ? getThemeValue(props, key) : null;
    var computedVariants = merge(assign({}, variants), themeVariants);
    var value = props[prop] !== undefined ? props[prop] : defaultValue;
    var result = getThemeValue(props, value, computedVariants);
    warn(is(result), "variant \"" + value + "\" not found");
    return result;
  };
};

var up = function up(key, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var value = getBreakpointMin(breakpoints, key);
    if (value === null) return rules;
    return [mediaMinWidth(value) + " {", rules, '}'];
  };
};
var down = function down(key, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var value = getBreakpointMax(breakpoints, key);
    if (value === null) return null;
    return [mediaMaxWidth(value) + " {", rules, '}'];
  };
};
var between = function between(lower, upper, rules) {
  return function (props) {
    var breakpoints = getBreakpoints(props);
    var min = getBreakpointMin(breakpoints, lower);
    var max = getBreakpointMax(breakpoints, upper);
    if (max === null) return up(lower, rules)(props);
    if (min === null) return down(upper, rules)(props);
    return [mediaBetweenWidth(min, max) + " {", rules, '}'];
  };
};
var breakpoints = function breakpoints(values) {
  return function (props) {
    var allRules = [];
    var keys = Object.keys(values);
    var keysLength = keys.length;

    for (var i = 0; i < keysLength; i++) {
      var key = keys[i];
      var rules = values[key];
      var result = up(key, rules)(props);

      if (Array.isArray(result)) {
        result.forEach(function (v) {
          return allRules.push(v);
        });
      } else {
        allRules.push(result);
      }
    }

    return allRules;
  };
};

var createSystemComponent = function createSystemComponent(_ref, defaultComponent, system$1) {
  var createElement = _ref.createElement,
      forwardRef = _ref.forwardRef;

  if (defaultComponent === void 0) {
    defaultComponent = 'div';
  }

  if (system$1 === void 0) {
    system$1 = system;
  }

  var SystemComponent = forwardRef(function SystemComponent(_ref2, ref) {
    var as = _ref2.as,
        props = _objectWithoutPropertiesLoose(_ref2, ["as"]);

    var omittedProps = omit(props, system$1.meta.props);
    var Component = as || defaultComponent;
    return createElement(Component, _extends._extends({
      ref: ref
    }, omittedProps));
  });
  SystemComponent.displayName = 'SystemComponent';
  return SystemComponent;
};

/* eslint-disable no-undef */
function useThemeBreakpoints(theme) {
  return getBreakpoints({
    theme: theme
  });
}
/**
 * Minimum breakpoint width.
 * Null for the smallest breakpoint.
 */

function useThemeMinValue(theme, key) {
  var breakpoints = useThemeBreakpoints(theme);
  var value = breakpoints[key];
  return value === 0 ? null : value;
}
/**
 * Maximum breakpoint width. Null for the largest (last) breakpoint.
 * The maximum value is calculated as the minimum of the next one less 0.02px
 * to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
 * See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
 * Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
 * See https://bugs.webkit.org/show_bug.cgi?id=178261
 */


function useThemeMaxValue(theme, key) {
  var breakpoints = useThemeBreakpoints(theme);
  var breakPoint = breakpoints[key];
  return breakPoint === 0 ? null : breakPoint - 0.02;
}

function useViewportWidth() {
  var _React$useState = React__default['default'].useState(typeof window === 'undefined' ? null : window.innerWidth),
      width = _React$useState[0],
      setWidth = _React$useState[1];

  React__default['default'].useEffect(function () {
    function handleResize() {
      setWidth(window.innerWidth);
    } // Add the listener, then setWidth to avoid race.


    window.addEventListener('resize', handleResize);
    setWidth(window.innerWidth);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
}
function useThemeBreakpoint(theme) {
  var breakpoints = useThemeBreakpoints(theme);
  var width = useViewportWidth();
  return React__default['default'].useMemo(function () {
    return Object.keys(breakpoints).reverse().find(function (breakpoint) {
      return width > breakpoints[breakpoint];
    }) || null;
  }, [breakpoints, width]);
}
function useThemeUp(theme, key) {
  var value = useThemeMinValue(theme, key);
  var width = useViewportWidth();
  return width >= value;
}
function useThemeDown(theme, key) {
  var value = useThemeMaxValue(theme, key);
  var width = useViewportWidth();
  return width < value;
}

function createBox() {
  return ["&&{", system, "}"];
}
createBox.meta = system.meta;

var getNumber = function getNumber(transform) {
  return function (value) {
    var num = Number(value);
    return transform(Number.isNaN(num) ? value : num);
  };
};

var SPACES = /\s+/;

var getMultiDimensions = function getMultiDimensions(transform) {
  return function (value) {
    var values = value.split(SPACES);
    return function (p) {
      return values.map(function (value) {
        return transform(value)(p);
      }).join(' ');
    };
  };
};

var COMMA = /\s*,\s*/;

var getMultiValues = function getMultiValues(transform) {
  return function (value) {
    var values = value.split(COMMA);
    return function (p) {
      return values.map(function (value) {
        return transform(value)(p);
      }).join(',');
    };
  };
};

var getNumberPx = /*#__PURE__*/getNumber(getPx);
var getNumberSpace = /*#__PURE__*/getNumber(getSpace);
var getMultiNumberSpace = /*#__PURE__*/getMultiDimensions(getNumberSpace);
var getNumberBorder = /*#__PURE__*/getNumber(getBorder);
var getNumberBorderWidth = /*#__PURE__*/getNumber(getBorderWidth);
var getMultiNumberBorderWidth = /*#__PURE__*/getMultiDimensions(getNumberBorderWidth);
var getNumberSize = /*#__PURE__*/getNumber(getSize);
var getMultiBorderStyle = /*#__PURE__*/getMultiDimensions(getBorderStyle);
var propGetters = {
  // getSpace
  margin: getMultiNumberSpace,
  'margin-top': getNumberSpace,
  'margin-bottom': getNumberSpace,
  'margin-left': getNumberSpace,
  'margin-right': getNumberSpace,
  padding: getMultiNumberSpace,
  'padding-top': getNumberSpace,
  'padding-bottom': getNumberSpace,
  'padding-left': getNumberSpace,
  'padding-right': getNumberSpace,
  'grid-gap': getMultiNumberSpace,
  'grid-row-gap': getNumberSpace,
  'grid-column-gap': getNumberSpace,
  // getColor
  color: getColor,
  'background-color': getColor,
  'border-color': getColor,
  'border-top-color': getColor,
  'border-right-color': getColor,
  'border-bottom-color': getColor,
  'border-left-color': getColor,
  'outline-color': getColor,
  fill: getColor,
  // getRadius
  'border-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(getRadius)),
  'border-top-left-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(getRadius)),
  'border-top-right-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(getRadius)),
  'border-bottom-right-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(getRadius)),
  'border-bottom-left-radius': /*#__PURE__*/getMultiDimensions( /*#__PURE__*/getNumber(getRadius)),
  // getBorder
  border: getNumberBorder,
  'border-top': getNumberBorder,
  'border-right': getNumberBorder,
  'border-bottom': getNumberBorder,
  'border-left': getNumberBorder,
  // getBorderWidth
  'border-width': getMultiNumberBorderWidth,
  'border-top-width': getNumberBorderWidth,
  'border-right-width': getNumberBorderWidth,
  'border-bottom-width': getNumberBorderWidth,
  'border-left-width': getNumberBorderWidth,
  'outline-width': getNumberBorderWidth,
  // getBorderStyle
  'border-style': getMultiBorderStyle,
  'border-top-style': getBorderStyle,
  'border-right-style': getBorderStyle,
  'border-bottom-style': getBorderStyle,
  'border-left-style': getBorderStyle,
  'outline-style': getBorderStyle,
  // getShadow
  'box-shadow': /*#__PURE__*/getMultiValues(getShadow),
  'text-shadow': /*#__PURE__*/getMultiValues(getShadow),
  // getSize
  width: getNumberSize,
  height: getNumberSize,
  'max-width': getNumberSize,
  'max-height': getNumberSize,
  'min-width': getNumberSize,
  'min-height': getNumberSize,
  // getZIndex
  'z-index': /*#__PURE__*/getNumber(getZIndex),
  // getFont
  'font-family': getFont,
  // getFontSize
  'font-size': /*#__PURE__*/getNumber(getFontSize),
  // getLineHeight
  'line-height': /*#__PURE__*/getNumber(getLineHeight),
  // getFontWeight
  'font-weight': getFontWeight,
  // getLetterSpacing
  'letter-spacing': /*#__PURE__*/getNumber(getLetterSpacing),
  // getTransition
  transition: getTransition,
  // getPx
  top: getNumberPx,
  right: getNumberPx,
  bottom: getNumberPx,
  left: getNumberPx
};

/* eslint-disable no-continue, no-loop-func, no-cond-assign */
var PROP_REGEXP = /(\s*)([^&{}:;\n]+):\s*([^&{}:;\n]+)(\s*);/g;
var IMPORTANT_REGEXP = /\s*!important\s*/;
function transform(rawValue) {
  if (typeof rawValue !== 'string') return rawValue;
  var matches;
  var lastIndex = 0;
  var values = [];

  var _loop = function _loop() {
    var _matches = matches,
        start = _matches[1],
        prop = _matches[2],
        propValue = _matches[3],
        end = _matches[4];
    var getter = propGetters[prop];

    if (getter) {
      var hasImportant = IMPORTANT_REGEXP.test(propValue);
      var cleanValue = propValue.replace(IMPORTANT_REGEXP, '');
      values.push(rawValue.slice(lastIndex, matches.index));
      values.push(function (p) {
        return "" + start + prop + ": " + getter(cleanValue)(p) + (hasImportant ? ' !important' : '') + ";" + end;
      });
      lastIndex = matches.index + matches[0].length;
    }
  };

  while (matches = PROP_REGEXP.exec(rawValue)) {
    _loop();
  }

  values.push(rawValue.slice(lastIndex, rawValue.length));
  return values;
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React__default['default'].useLayoutEffect : React__default['default'].useEffect;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/* eslint-disable no-continue, no-loop-func, no-cond-assign */
function css() {
  var scCssArgs = styled$1.css.apply(void 0, arguments);
  var flattenedArgs = flattenStrings(scCssArgs);
  return flattenedArgs.map(transform);
}

var createGlobalStyle = function createGlobalStyle() {
  return styled$1.createGlobalStyle([css.apply(void 0, arguments)]);
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function getCreateStyle(baseCreateStyle) {
  var createStyle = function createStyle() {
    return baseCreateStyle(_templateObject(), css.apply(void 0, arguments));
  };

  createStyle.attrs = function (attrs) {
    var nextCreateStyle = baseCreateStyle.attrs(attrs);
    return getCreateStyle(nextCreateStyle);
  };

  createStyle.withConfig = function (config) {
    var nextCreateStyle = baseCreateStyle.withConfig(config);
    return getCreateStyle(nextCreateStyle);
  };

  return createStyle;
}

function styled(component) {
  return getCreateStyle(styled__default['default'](component));
}
var InnerBox = /*#__PURE__*/createSystemComponent(React__default['default']);
var Box = /*#__PURE__*/styled(InnerBox)(createBox);
styled.box = /*#__PURE__*/styled(Box);
Object.keys(styled__default['default']).forEach(function (key) {
  styled[key] = styled(key);
  styled[key + "Box"] = styled(Box.withComponent(createSystemComponent(React__default['default'], key)));
});

function useTheme() {
  return React__default['default'].useContext(styled$1.ThemeContext);
}

function useBreakpoints() {
  return useThemeBreakpoints(useTheme());
}
function useBreakpoint() {
  return useThemeBreakpoint(useTheme());
}
function useUp(key) {
  return useThemeUp(useTheme(), key);
}
function useDown(key) {
  return useThemeDown(useTheme(), key);
}

exports._objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
exports.background = background;
exports.backgroundColor = backgroundColor;
exports.backgroundPosition = backgroundPosition;
exports.backgroundRepeat = backgroundRepeat;
exports.backgroundSize = backgroundSize;
exports.backgrounds = backgrounds;
exports.between = between;
exports.borders = borders;
exports.boxShadow = boxShadow;
exports.breakpoints = breakpoints;
exports.compose = compose;
exports.createGlobalStyle = createGlobalStyle;
exports.createStyleGenerator = createStyleGenerator;
exports.createSystemComponent = createSystemComponent;
exports.css = css;
exports.down = down;
exports.flexboxes = flexboxes;
exports.getColor = getColor;
exports.getPercent = getPercent;
exports.getSpace = getSpace;
exports.grids = grids;
exports.height = height;
exports.layout = layout;
exports.margin = margin;
exports.marginBottom = marginBottom;
exports.marginLeft = marginLeft;
exports.marginRight = marginRight;
exports.marginTop = marginTop;
exports.maxHeight = maxHeight;
exports.maxWidth = maxWidth;
exports.merge = merge;
exports.minHeight = minHeight;
exports.minWidth = minWidth;
exports.obj = obj;
exports.opacity = opacity;
exports.order = order;
exports.overflow = overflow;
exports.padding = padding;
exports.paddingBottom = paddingBottom;
exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.paddingTop = paddingTop;
exports.positioning = positioning;
exports.reduceBreakpoints = reduceBreakpoints;
exports.size = size;
exports.space = space;
exports.style = style;
exports.styled = styled;
exports.textAlign = textAlign;
exports.th = th;
exports.themeGetter = themeGetter;
exports.transition = transition;
exports.up = up;
exports.useBreakpoint = useBreakpoint;
exports.useBreakpoints = useBreakpoints;
exports.useDown = useDown;
exports.useUp = useUp;
exports.useViewportWidth = useViewportWidth;
exports.variant = variant;
exports.verticalAlign = verticalAlign;
exports.width = width;
//# sourceMappingURL=xstyled-styled-components.es-6e2bde7d.js.map
